module.exports = __webpack_public_path__ + "static/media/channel-generic.1f363478.svg";